import {makeAutoObservable} from "mobx";
import type {PpvLevelStatisticsTreeSerializer} from "../../../../services/classes/MaterializedClasses";
import type {MithraMaterializedApi} from "../../../../services/MithraMaterializedApi";
import {AxoisRequestManager} from "../../../../stores/managers/RequestManager";
import {from} from "rxjs";
import type {PpvAllLevelsFilter} from "../classes/PpvApiClasses";


export class PpvPageStatisticsController {
    constructor(
        private api: MithraMaterializedApi,
    ) {
        makeAutoObservable(this)
    }

    reset() {
        this._ppvLevelStatistics.cleanup()
    }

    request(filter: PpvAllLevelsFilter) {
        this._ppvLevelStatistics.request(filter)
    }


    get reviewLevelStatistics(): PpvLevelStatisticsTreeSerializer | undefined {
        return this._ppvLevelStatistics.result?.at(0);
    }

    get rootPpv(): number | null {
        return this.reviewLevelStatistics ? this.reviewLevelStatistics.values.total_ppv_opportunity ?? 0 : null;
    }

    get rootSpend(): number | null {
        return this.reviewLevelStatistics ? this.reviewLevelStatistics.values.total_spend ?? 0 : null;
    }

    get rootSuppliers(): number | null {
        return this.reviewLevelStatistics ? this.reviewLevelStatistics.values.n_suppliers ?? 0 : null;
    }

    readonly _ppvLevelStatistics = new AxoisRequestManager<PpvAllLevelsFilter, [PpvLevelStatisticsTreeSerializer]>(
        (f) => from(this.api.listPpvLevelStatistics(f))
    );
}